<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-green">
        <icon
          data="@icon/goal-complete.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <div class="notification-title-flex">
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
        >
          Project has a new Goal!
        </BaseSubHeading>
        <BaseSubHeading
          size="small"
          color="monochrome-05"
          darkColor="monochrome-04"
          weight="500"
          class="project-section"
        >
          {{ notification.projectName }}
        </BaseSubHeading>
      </div>
    </template>
    <template #content>
      <div class="new-current-goal__content">
        <a
          class="link is-medium goal-title"
          target="_blank"
          :href="notification.goalUrl"
        >
          {{ notification.currentGoalContent }}
        </a>

        <div
          v-if="notification.videoUrl || fileMetadata"
          class="goal-video"
        >
          <VideoPreview
            :playerId="notification.id"
            :videoUrl="notification.videoUrl ?? ''"
            :fileMetadata="fileMetadata"
            :projectId="notification.projectId ?? ''"
            class="notification__attachment-video"
          />
        </div>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts" setup>
import { computed } from "vue"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import VideoPreview from "@/components/VideoPlayer/VideoPreview.vue"

import { NotificationGoal } from "@/models/Notification"

const props = defineProps({
  notification: {
    type: Object as () => NotificationGoal,
    required: true
  }
})

const fileMetadata = computed(() => {
  const attachments = props.notification.attachmentsMetadata?.attachments
  if (attachments && attachments.length > 0) {
    const videoFile = attachments.find(
      (a: any) => a.name?.endsWith(".mp4") || a.name?.endsWith(".webm") || a.name?.endsWith(".mov")
    )
    return videoFile || null
  }
  return null
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/_flex";

.notification-title-flex {
  @include flex($justify: space-between, $align: center);

  gap: 4px;
}

.new-current-goal__content {
  margin-top: var(--step2);
}

.goal-title {
  display: block;
  margin-bottom: var(--step2);
}

.goal-field {
  margin-top: var(--step1);
}

.goal-video {
  .notification__attachment-video {
    max-width: 192px;
    height: 108px;

    .video-attachment {
      border-color: var(--monochrome-02);
    }

    @media (max-width: 1536px) {
      max-width: 148px;
      height: 84px;
    }

    @media (max-width: 1280px) {
      max-width: 132px;
      height: 75px;
    }
  }
}
</style>
